import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { PasswordValidation } from '../../mnt-admin/password-validation';
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { FlashMessagesService } from "angular2-flash-messages";

@Component({
  selector: 'app-staff-form',
  templateUrl: './staff-form.component.html',
  styleUrls: ['./staff-form.component.css']
})

export class StaffFormComponent implements OnInit {

  staffForm: FormGroup;

  @Input() activeRole: string; // the current page
  @Output() toggleForm = new EventEmitter<boolean>();
  public pageHeader = "";
  constructor(private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private CommonService: CommonService) {
  }

  ngOnInit() {
    if (this.activeRole == 'printers') {
      this.pageHeader = "Printers Management";
      this.staffForm = this.formBuilder.group({
        company_name: [null],
        site_url: [null, Validators.pattern('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$')],
        first_name: [null, Validators.required],
        last_name: [null, Validators.required],
        //middle_name: [null],
        email: [null, Validators.email],
        phone: [null],
        username: [null, Validators.minLength(5)],
        password: [null, Validators.minLength(8)],
        confirm_password: [null, Validators.required],
        address1: [null],
        address2: [null],
        city: [null],
        state: [null],
        zip: [null]
      }, {
        validator: PasswordValidation.MatchPassword // your validation method
      });
    }
    else {
      this.pageHeader = "Designers Management";
      this.staffForm = this.formBuilder.group({
        company_name: [null],
        site_url: [null, Validators.pattern('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$')],
        first_name: [null, Validators.required],
        last_name: [null, Validators.required],
        //middle_name: [null],
        email: [null, Validators.email],
        phone: [null],
        username: [null, Validators.minLength(5)],
        password: [null, Validators.minLength(8)],
        confirm_password: [null, Validators.required]
      }, {
        validator: PasswordValidation.MatchPassword // your validation method
      });
    }
  }

  backToList(): void {
    this.toggleForm.emit();
  }

  isFieldValid(field: string) {
    return (
      !this.staffForm.get(field).valid &&
      this.staffForm.get(field).touched
    );
  }

  displayFieldCss(field: string) {
    return {
      "has-error": this.isFieldValid(field),
      "has-feedback": this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  saveStaffFormData = function (postData) {
    if (this.staffForm.valid) {
      this.staffOptions = {
        id: localStorage.getItem("userID"),
        company_name: postData.company_name,
        first_name: postData.first_name,
        last_name: postData.last_name,
        //middle_name: postData.middle_name,
        username: postData.username,
        password: postData.password,
        site_url: postData.site_url,
        email: postData.email,
        phone: postData.phone,
        confirm_password: postData.confirm_password
      };
      if (this.activeRole == 'printers') {
        this.staffOptions.address1 = postData.address1;
        this.staffOptions.address2 = postData.address2;
        this.staffOptions.city = postData.city;
        this.staffOptions.state = postData.state;
        this.staffOptions.zip = postData.zip;
      }
      let active_url = (this.activeRole == 'designers') ? 'designer' : 'printer';
      this.CommonService.apiService(
        "POST",
        active_url + "/create",
        this.staffOptions
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.staffForm.reset();
            this.backToList();
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
          }

          window.scrollTo(0, 0);
        },
        err => {
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.staffForm);
    }
  };

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/staff-form/staff-form.component.ts